var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-row',[_c('v-col',[_c('project-setting-list',{attrs:{"min-card-height":600}})],1),_c('v-col',[_c('project-setting-edit',{attrs:{"minCardHeight":600}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }